import round from 'lodash/round';

import { normalizeMillis, TimeUnit, toNumOrUndefined } from '@cast/utils';

type FormattedLatency = {
  value: number;
  unit: TimeUnit;
};

export const formatLatency = (
  value: number | string | null | undefined,
  roundBy = 2
): FormattedLatency | undefined => {
  const num = toNumOrUndefined(value);
  if (num === undefined) {
    return undefined;
  }

  const normalized = normalizeMillis(num, {
    roundingBreakpoint: roundBy,
    maxGranularity: 's',
  });

  return {
    value: round(normalized.value, roundBy),
    unit: normalized.unit,
  };
};
